<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: "Microsoft YaHei", sans-serif;
  background: #f8f9fa;
  line-height: 1.6;
}
.container {
  width: 92%;
  max-width: 1200px;
  margin: 0 auto;
}
/* 导航栏 */
.navbar {
  background: #fff;
  padding: 15px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.navbar .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}
.logo-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.logo-sub {
  font-size: 12px;
  color: #999;
  font-weight: normal;
}
.nav {
  display: flex;
  list-style: none;
  gap: 25px;
}
.nav a {
  color: #333;
  text-decoration: none;
  font-size: 15px;
  cursor: pointer;
  transition: color 0.2s;
}
.nav a:hover {
  color: #0066ff;
}
.login-box {
  display: flex;
  align-items: center;
  gap: 10px;
}
.nav-btn {
  margin-right: 8px !important;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
/* 页脚 */
.footer {
  background: #111;
  color: #fff;
  text-align: center;
  padding: 30px 0;
}
.footer p {
  color: #aaa;
  font-size: 14px;
}
</style>
